import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=1c389a14&scoped=true"
import script from "./organization.vue?vue&type=script&lang=js"
export * from "./organization.vue?vue&type=script&lang=js"
import style0 from "./organization.vue?vue&type=style&index=0&id=1c389a14&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c389a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c389a14')) {
      api.createRecord('1c389a14', component.options)
    } else {
      api.reload('1c389a14', component.options)
    }
    module.hot.accept("./organization.vue?vue&type=template&id=1c389a14&scoped=true", function () {
      api.rerender('1c389a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/InventoryManagement/Inventory/form/add/components/organization.vue"
export default component.exports